export const SPACER_XXL_PX = 24;
export const SCROLL_DELAY = 500;
